module.exports = {"410221100":"城关镇","410221101":"五里河镇","410221102":"傅集镇","410221103":"圉镇镇","410221104":"高阳镇","410221105":"葛岗镇","410221106":"阳堌镇","410221107":"邢口镇","410221200":"裴村店乡","410221202":"宗店乡","410221203":"板木乡","410221204":"竹林乡","410221205":"官庄乡","410221206":"湖岗乡","410221207":"苏木乡","410221208":"沙沃乡","410221209":"平城乡","410221210":"泥沟乡","410221211":"柿园乡","410221212":"西寨乡","410221213":"城郊乡","410221401":"工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410221.json
// module id = 1534
// module chunks = 0